// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"cd1df864","894":"e8bc9ed9"}[chunkId] + ".chunk.css";
};